<section class="banner-comp banner-padding">
	<div class="container">
		<div class="row sub-headers-inside ">
			<div class="col-12 text-center my-auto">

				<div class="col-12 m-auto text-center">
					<div class="overlap-signature header-inside">
						<span class="letter"> <span class="signature-text">Comparte </span></span>
						<h1 class="main-text"> tus boletos</h1>
					</div>
				</div>


			</div>
		</div>
	</div>
</section>


<!-- Modal: uno o más boletos ya no están disponibles -->
<div class="modal-liga-backdrop" *ngIf="mostrarModalNoDisponibles">
	<div class="modal-liga-card">
		<h3 style="color:#2d2d6b;text-align:center;">Algunos boletos ya no están disponibles</h3>

		<!-- Un renglón por boleto, con su motivo real y el folio en negrita.
		     Mismo formato que el modal del carrito. -->
		<div style="text-align:left;max-height:44vh;overflow-y:auto;margin:18px 0 6px;">
			<div *ngFor="let m of mensajesNoDisponibles"
			     style="margin:0 0 12px;padding:12px 14px;background:#fff6f1;border-left:4px solid #ff5900;border-radius:6px;color:#4a4a4a;font-size:0.97rem;line-height:1.5;">
				<ng-container *ngFor="let t of m"><strong *ngIf="t.b" style="font-weight:bold;color:#eb4d10;">{{ t.t }}</strong><ng-container *ngIf="!t.b">{{ t.t }}</ng-container></ng-container>
			</div>
		</div>

		<p style="font-size:1rem;text-align:center;color:#6b6b6b;">
			Ya actualizamos la lista para que puedas elegir de nuevo.
		</p>
		<div style="text-align:center;">
			<button class="btn-stack" (click)="cerrarModalNoDisponibles()">Entendido</button>
		</div>
	</div>
</div>

<!-- Modal: error al validar -->
<div class="modal-liga-backdrop" *ngIf="mostrarModalError">
	<div class="modal-liga-card text-center">
		<h3 style="color:#2d2d6b;">No pudimos validar tus boletos</h3>
		<p style="font-size:1.05rem;">
			Ocurrió un problema de conexión. Por favor vuelve a intentarlo en unos segundos.
		</p>
		<button class="btn-stack" (click)="cerrarModalError()">Reintentar</button>
	</div>
</div>


<section class="section-colabora">
	<div class="container">
		<div class="row">
			<!-- LOGO -->
			<div class="col-md-12 text-center">
				<h1> BOLETOS RECOMENDADOS</h1>
			</div>

			<div class="col-md-12 text-center" *ngIf="boletos_colaborador.length !== 0">

				<h2>Elige los boletos que le desees comprar a {{nombre_colaborador}}:</h2>

				<!-- ARRIBA A PROPOSITO. Va antes de la lista para que se vea sin bajar:
				     si estuviera al final, el colaborador contaria sus boletos, no le
				     cuadrarian con los de su app, y preguntaria. Compacto para no
				     empujar la lista ni el boton. -->
				<div *ngIf="boletosEnEspera.length !== 0"
				     style="max-width:720px;margin:22px auto 0;padding:14px 18px;background:#fff8f4;border:1px solid #ffd7c2;border-left:5px solid #ff5900;border-radius:8px;text-align:left;">

					<div style="display:flex;align-items:center;gap:9px;margin-bottom:4px;">
						<span style="font-size:1.1rem;line-height:1;">⏳</span>
						<strong style="color:#2d2d6b;font-size:1.02rem;">
							{{ boletosEnEspera.length }}
							{{ boletosEnEspera.length === 1 ? 'boleto tuyo esta' : 'boletos tuyos estan' }}
							en espera de un pago
						</strong>
					</div>

					<p style="color:#6b6b6b;font-size:0.9rem;margin:0 0 12px;line-height:1.45;">
						<strong>Siguen siendo tuyos</strong>, pero ahora no se pueden vender.
						Si el pago no se concreta, vuelven solos a la lista de abajo.
					</p>

					<div *ngFor="let b of boletosEnEspera"
					     style="display:flex;align-items:center;gap:13px;margin:0 0 8px;padding:11px 13px;background:#fff;border:1px solid #f3e2d6;border-radius:7px;">
						<span style="font-family:'Courier New',monospace;font-weight:bold;color:#fff;background:#eb4d10;font-size:0.98rem;letter-spacing:.06em;padding:6px 11px;border-radius:5px;white-space:nowrap;">{{ b.folio }}</span>
						<span style="color:#4a4a4a;font-size:0.92rem;line-height:1.45;text-align:left;">
							<ng-container *ngFor="let t of b.partes"><strong *ngIf="t.b" style="color:#c2410c;">{{ t.t }}</strong><ng-container *ngIf="!t.b">{{ t.t }}</ng-container></ng-container>
						</span>
					</div>
				</div>

				<div class="row BoletosPay center texto-primario mt-5 b-0" *ngIf="boletos_colaborador.length !== 0">
					<div *ngFor="let boleto of boletos_colaborador" class="col-lg-4 col-6">
						<!-- <div *ngFor="let boleto of boletos_colaborador" class="col-xs-6 col-sm-12 col-md-12 col-lg-12 col-xl-12 texto-primario"> -->
						<!-- <div *ngFor="let boleto of boletos_colaborador" class="texto-primario"style="display: inline-block;">  -->
						<label>
							<input type="checkbox" [(ngModel)]="boleto.seleccionado" checked="false">
							<span>
								{{boleto.folio}}
							</span>
						</label>
					</div>
				</div>

				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-lg-offset-2 col-xl-offset-2"
					style="margin: 5% 0;">
					<!-- <button *ngIf="boletos_colaborador.length !== 0" (click)="add(boletos_colaborador);" class="btn btn-secondary">AGREGAR <img src="../../assets/img/AHC_LP_IconoCarritoBlanco.png"></button> -->
					<button (click)="add(boletos_colaborador);" *ngIf="boletos_colaborador.length !== 0"
						class="btn-stack" [disabled]="validandoBoletos">
						{{ validandoBoletos ? 'Validando…' : 'Agregar al carrito' }}
					</button>

					<p *ngIf="mostrarMensajeSeleccion" class="mt-3" style="color: #fc5705;">
						Selecciona al menos un boleto para continuar.
					</p>
				</div>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 center"
				*ngIf="boletos_colaborador.length == 0 && boletosEnEspera.length == 0">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 margen-to mb-5">
					<h2>Lo sentimos, por el momento no contamos con boletos disponibles.</h2>
				</div>
			</div>

			<!-- Todos sus boletos estan en espera: no es "no hay boletos", es "espera un rato" -->
			<div class="col-md-12 center" *ngIf="boletos_colaborador.length == 0 && boletosEnEspera.length !== 0">
				<div class="col-md-12 margen-to mb-5">
					<h2 style="font-size:1.4rem;">
						Por ahora todos los boletos tienen un pago en proceso.
						Revisa arriba las horas en que se liberan y vuelve a intentar entonces.
					</h2>
				</div>
			</div>


		</div>

	</div>
</section>